import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  TextField,
  Box,
} from "@mui/material";
import {
  Reports,
  resetFilters,
  setFilters,
} from "../../../app/slices/reportsSlice";
import dayjs from "dayjs";
import { SelectEmployee } from "../../../components/Selects/SelectEmployee";
import { SelectDepartment } from "../../../components/Selects/SelectDepartment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EmployeeTicketReportFilters = () => {
  const dispatch = useDispatch();
  const {
    filters: { employeeTicketReport },
  } = useSelector((state) => state.reports);

  useEffect(() => {
    return () => dispatch(resetFilters({ type: "employeeTicketReport" }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" component="div">
            Employee Tickets Report
          </Typography>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
        <Grid item xs={3}>
            <SelectDepartment
              fullWidth
              value={employeeTicketReport.department_id}
              disabled={!!employeeTicketReport.employee_id}
              onChange={(e, value) => {
                dispatch(
                  setFilters({
                    type: "employeeTicketReport",
                    data: {
                      department_id: value ? value : null,
                      employee_id: null,
                    },
                  })
                );
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <SelectEmployee
              fullWidth
              value={employeeTicketReport.employee_id}
              disabled={!!employeeTicketReport.department_id}
              onChange={(e, value) => {
                dispatch(
                  setFilters({
                    type: "employeeTicketReport",
                    data: {
                      employee_id: value ? value : null,
                      department_id: null,
                    },
                  })
                );
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              localeText={{ start: "From-Date", end: "To-Date" }}
            >
              <DateRangePicker
                value={[
                  employeeTicketReport.start_date,
                  employeeTicketReport.end_date,
                ]}
                onChange={(newValue) => {
                  dispatch(
                    setFilters({
                      type: "employeeTicketReport",
                      data: {
                        start_date: newValue[0]
                          ? dayjs(newValue[0]).format("YYYY-MM-DD")
                          : null,
                        end_date: newValue[1]
                          ? dayjs(newValue[1]).format("YYYY-MM-DD")
                          : null,
                      },
                    })
                  );
                }}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField {...startProps} size="small" />
                    <Box sx={{ mx: 2 }}> to </Box>
                    <TextField {...endProps} size="small" />
                  </>
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              disabled={
                !employeeTicketReport.employee_id &&
                !employeeTicketReport.department_id
              }
              onClick={() => {
                dispatch(Reports.fetch("employeeTicketReport"));
              }}
              sx={{
                textTransform: "capitalize",
              }}
            >
              Show results
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EmployeeTicketReportFilters;

